import { getCountryFromCookie } from '@common/utils/cookie-utils'
import { COUNTRIES } from '@common/constants'
import { connectRedux, formatDate, GoToComponentProps } from '@common/utils'
import {
    LmiProCheckoutFormContainerActionsType,
    mapLmiProCheckoutFormContainerActions,
    mapLmiProCheckoutFormContainerState,
} from '@lmipro/connectedComponents/CheckoutFormContainer/connector'
import { LmiProCheckoutFormContainerState } from '@lmipro/state/checkout-form-container/state'
import { LmiProBuyFormData } from '@lmipro/state/buy-form/state'
import { CheckoutSchema } from '@lmipro/utils'
import { Formik, FormikProps } from 'formik'
import React, { FunctionComponent, useEffect, useRef } from 'react'
import { ConvertStringToReact } from '@common/components'
import { ConnectedCheckoutForm } from '../CheckoutForm'

type LmiProCheckoutFormContainerProps = GoToComponentProps<
    LmiProCheckoutFormContainerState,
    LmiProCheckoutFormContainerActionsType,
    {
        isTabletOrMobileView?: boolean
        isMobileView?: boolean
        setHasAddressValidationErrors: React.Dispatch<React.SetStateAction<boolean>>
        setGeneralFieldErrors: React.Dispatch<React.SetStateAction<boolean>>
        setHasCardValidationErrors: React.Dispatch<React.SetStateAction<boolean>>
        hasAddressValidationErrors: boolean
        generalFieldErrors: boolean
        hasCardValidationErrors: boolean
    }
>

export const LmiProCheckoutFormContainer: FunctionComponent<LmiProCheckoutFormContainerProps> = ({
    state,
    props,
    actions,
}) => {
    const formikRef = useRef<FormikProps<LmiProBuyFormData>>(null)
    const isSubmittingRef = useRef<boolean>(false)
    // save form data when component unmounts
    useEffect(() => {
        const getFormValues = () => {
            return formikRef.current?.values
        }
        return () => {
            const formValues = getFormValues()
            if (formValues) {
                actions.updateInitialFormState(formValues)
            }
        }
    }, [actions])

    useEffect(() => {
        /* eslint-disable no-param-reassign */
        state.initialData.CountryCode = getCountryFromCookie() || COUNTRIES.US
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Formik
                initialValues={state.initialData}
                validationSchema={() => CheckoutSchema(state.initialData.CountryCode, state.errorContent)}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={(_values, formikBag) => {
                    formikBag.setSubmitting(false)
                }}
                innerRef={formikRef}
            >
                {(formikProps) => {
                    if (formikProps.isSubmitting) {
                        isSubmittingRef.current = true
                    }

                    if (isSubmittingRef.current && !formikProps.isSubmitting) {
                        isSubmittingRef.current = false
                    }
                    return (
                        <ConnectedCheckoutForm
                            {...props}
                            initialData={state.initialData}
                            errorContent={state.errorContent}
                            formikRef={formikRef}
                            isSubmittingRef={isSubmittingRef}
                        />
                    )
                }}
            </Formik>
            {state.isCouponValidAndApplied && state.couponServerData?.validTo && (
                <div data-qat="disclaimer-message">
                    <ConvertStringToReact
                        htmlString={state.content.couponDisclaimer.replace(
                            '{couponExpDate}',
                            formatDate(new Date(state.couponServerData?.validTo), 'UTC', state.locale)
                        )}
                    />
                </div>
            )}
        </>
    )
}

export const ConnectedLmiProCheckoutFormContainer = connectRedux(
    LmiProCheckoutFormContainer,
    mapLmiProCheckoutFormContainerState,
    mapLmiProCheckoutFormContainerActions
)
